shadow$provide[442] = function(require,module,exports) {
module.exports=(ReactDOM);
};